import type { TestRunDetails } from "../types";

type WorklistWithCodes = {
  name: string;
  originalTestSpecs: { code: string }[];
};

/** Distinct spec codes for a grouped worklist (merged rows share a display name). */
export function worklistCodes(worklist: WorklistWithCodes): string {
  return [...new Set(worklist.originalTestSpecs.map((t) => t.code))].join(", ");
}

/** Plain-text label for titles and breadcrumbs: `Name (CODE)` or `Name (A, B)` when merged. */
export function worklistNameWithCodes(worklist: WorklistWithCodes): string {
  return `${worklist.name} (${worklistCodes(worklist)})`;
}

type TestOrder = TestRunDetails["testSpecs"][number]["testOrders"][number];

export function getProgressValues(testOrders: TestOrder[]) {
  const total = testOrders.length;
  const completed = testOrders.filter(
    (order) =>
      order.cancelled || !order.results.find((result) => !result.validated),
  ).length;
  const validating = testOrders.filter(
    (order) =>
      !order.cancelled &&
      order.results.find((result) => result.status === "initial"),
  ).length;
  const inProgress = total - completed - validating;

  return { total, completed, validating, inProgress };
}

export function getProgressValuesFromCounts(
  counts?: {
    pendingCount?: number | null;
    validatingCount?: number | null;
    completedCount?: number | null;
  } | null,
) {
  const completed = Number(counts?.completedCount || 0);
  const validating = Number(counts?.validatingCount || 0);
  const inProgress = Number(counts?.pendingCount || 0);
  const total = completed + validating + inProgress;

  return { total, completed, validating, inProgress };
}
